import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, User, Menu, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated, user } = useAuth();
  const { getCartCount } = useCart();
  const navigate = useNavigate();

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Portfolio', path: '/portfolio' },
    { label: 'Services', path: '/shop' },
    { label: 'Blog', path: '/blog' },
    { label: 'Social', path: '/social' },
    { label: 'Contact', path: '/contact' }
  ];

  // Navigate and scroll to top
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-gray-900">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="/" 
            onClick={(e) => { e.preventDefault(); handleNavigation('/'); }}
            className="flex items-center"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_enrigo-creative/artifacts/19zqfisl_EA%20Logo.png" 
              alt="Enrigo" 
              className="h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-12">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.path}
                onClick={(e) => { e.preventDefault(); handleNavigation(item.path); }}
                className="text-white hover:text-[#F4B400] transition-colors duration-300 text-sm font-medium tracking-wider"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Right Actions */}
          <div className="flex items-center space-x-6">
            {/* Cart */}
            <button
              onClick={() => handleNavigation('/cart')}
              className="relative text-white hover:text-[#F4B400] transition-colors duration-300"
            >
              <ShoppingCart size={20} />
              {getCartCount() > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#F4B400] text-black text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {getCartCount()}
                </span>
              )}
            </button>

            {/* User/Login */}
            {isAuthenticated ? (
              <Button
                onClick={() => handleNavigation('/dashboard')}
                variant="outline"
                className="hidden sm:flex border-[#F4B400] text-[#F4B400] hover:bg-[#F4B400] hover:text-black transition-all duration-300"
              >
                <User size={16} className="mr-2" />
                {user?.name?.split(' ')[0]}
              </Button>
            ) : (
              <Button
                onClick={() => handleNavigation('/login')}
                className="hidden sm:flex bg-[#F4B400] text-black hover:bg-[#d49f00] transition-all duration-300"
              >
                Login
              </Button>
            )}

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white hover:text-[#F4B400] transition-colors"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="lg:hidden mt-6 pb-4 border-t border-gray-900 pt-4">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.path}
                onClick={(e) => { e.preventDefault(); handleNavigation(item.path); }}
                className="block py-3 text-white hover:text-[#F4B400] transition-colors"
              >
                {item.label}
              </a>
            ))}
            {!isAuthenticated && (
              <a
                href="/login"
                onClick={(e) => { e.preventDefault(); handleNavigation('/login'); }}
                className="block py-3 text-[#F4B400] hover:text-white transition-colors font-medium"
              >
                Login
              </a>
            )}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
